import React from "react";
import Button from "../../../components/buttons/Button";
import { useNavigate, useParams } from "react-router-dom";
import { GetActivity } from "../../../hooks/useServiceData";

export const ActivityOverviewView = () => {
  const { id: activityId } = useParams();
  const navigate = useNavigate();
  const { data } = GetActivity(activityId);
  console.log("data: ", data);

  const clickEdit = (id) => {
    navigate(`/registry/activity/edit/${id}`);
  };

  return (
    <>
      <div className="container" style={{ width: "100%" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h2>{data?.data.name}</h2>
          <div>
            <Button onClick={() => clickEdit(activityId)}>Redigera</Button>
          </div>
        </div>
        <table className="vertical-table">
          <tbody>
            <tr>
              <th>ID</th>
              <td>{data?.data.id}</td>
            </tr>
            <tr>
              <th>Namn</th>
              <td>{data?.data.name}</td>
            </tr>
            <tr>
              <th>Ägare ID</th>
              <td>{data?.data.owner_id}</td>
            </tr>
            <tr>
              <th>Kostnad</th>
              <td>{data?.data.cost}</td>
            </tr>
            <tr>
              <th>Aktiv</th>
              <td>{data?.data.isActive ? "Ja" : "Nej"}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};
